import { render } from "./EditCategoryTitle.vue?vue&type=template&id=63776d94&scoped=true"
import script from "./EditCategoryTitle.vue?vue&type=script&lang=js"
export * from "./EditCategoryTitle.vue?vue&type=script&lang=js"

import "./EditCategoryTitle.vue?vue&type=style&index=0&id=63776d94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63776d94"]])

export default __exports__